<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <!-- 轮播图列表 -->
      <div class="bannerList" v-show="pageShow == 'index'">
        <!-- 顶部起始位置 -->
        <div class="topBox">
          <el-button type="success" size="small" @click="addBanner"
            >新增</el-button
          >
        </div>
        <!-- 顶部结束位置 -->

        <template>
          <el-table border :data="bannerData" style="width: 100%">
            <el-table-column align="center" label="图片">
              <template slot-scope="scope">
                <div class="bannerImg">
                  <img :src="scope.row.images | assetUrl" />
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="small"
                  @click="editBanner(scope.$index)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  size="small"
                  @click="delBanner(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <!-- 轮播入列表 -->

      <!-- 新增轮播 -->
      <div class="addBanner" v-show="pageShow == 'addBanner'">
        <div class="bannnerLi flex">
          <!-- <div class="title">图片：</div> -->
          <div style="width: 240px; height: 140px">
            <elUpload @getImg="getImgFn" :image="bannerList.images"></elUpload>
          </div>
        </div>

    

        <div class="bannnerLi flex">
          <el-button
            type="success"
            :disabled="submitShow"
            size="small"
            @click="submitBanner"
            >提交</el-button
          >
          <el-button type="info" size="small" @click="returnBanner"
            >返回</el-button
          >
        </div>
      </div>
      <!-- 新增轮播 -->
    </div>
  </div>
</template>


<script>
import { delTips,throttle} from "@/util/utils";
import wangEditor from "@/components/wangEditor";
import elUpload from "@/components/elUpload";
export default {
  components: {
    wangEditor,
    elUpload,
  },
  data() {
    return {
      // 历史记录
      historyArr: ["界面管理", "轮播图"],

      currentPage: 1,
      pageSize: 50,
      pageShow: "index",
      bannerData: [],

      //轮播列表
      submitShow: false,
      bannerList: {
        images: "",
      },
    };
  },
  created() {
    console.log(this.bannerList,'sdfs')
  },
  mounted() {
    this.selList(); //查询
  },
  methods: {
    // 添加历史
    historyFn(title, str) {
      this.historyArr.push(title);
      this.pageShow = str;
    },

    // 查询
    selList: function () {
      var urls = this.$api.api.selBanner;
      var data = {
          page:1,
          size:1000,
      };
      this.$https(urls, data, "POST").then((res) => {
        if (res.data.code == 200) {
          this.bannerData = res.data.data;
        }
      });
    },

    // 新增轮播
    addBanner: function (res) {
      this.historyFn("新增", "addBanner");
      this.submitShow = false;
      this.bannerList = {
        images: "",
      };
    },

    // 图片上传前
    beforeUpload: function (res) {},

    
    // 图片上传
    getImgFn: function (res) {
      console.log(res,'撒旦发射点');
      this.$set(this.bannerList, "images", res);
    },

    // 删除轮播
    delBanner: delTips(function (index) {
      var list = this.bannerData[index];
      this.$https(
        this.$api.api.delBanner,
        {
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.submitShow = false;
          this.$message.success("操作成功");
          setTimeout((res) => {
            this.submitShow = false;
            this.returnBanner();
          }, 1000);
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    // 图片保存
    bannerFn: function (res) {
      var data = this.bannerData;
    },

    // 轮播编辑
    editBanner: function (index) {
      var list = this.bannerData[index];
      this.historyArr.push("编辑");
      this.pageShow = "addBanner";
      this.bannerList = list;
    },

    // 轮播提交
    submitBanner:throttle(function (res) {
      var data = this.bannerList;
      if (!data.images) {
        this.$message.error("请上传图片");
        return;
      }

   

      var urls = "";
       var obj ={
         images:data.images,
       }
      if(data.id){
        urls =  this.$api.api.upBanner;
        obj.id = data.id;
      }else{
        urls =  this.$api.api.addBanner;
      }

 

      this.submitShow = true;
      this.$https(
       urls,
       obj,
        "POST"
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
      setTimeout((res) => {
        this.submitShow = false;
        this.returnBanner();
      }, 1000);
    }),

    // 轮播返回
    returnBanner: function (res) {
      this.historyArr.pop();
      this.pageShow = "index";
      this.selList(); //查询
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
  }

  .bannerTop {
    margin-bottom: 20px;
  }

  /* 头部起始位置 */
  .el-header {
    height: 50px !important;
    line-height: 50px;
    border-bottom: 2px solid #bebebe;
  }

  .banner {
    width: 100%;
    overflow: hidden;

    .el-icon-plus,
    img {
      width: 200px;
      height: 110px;
      border: 2px dashed #dedede;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      color: #999;
    }

    .Btn {
      background: red;
      margin-left: 15px;
    }
  }

  // 轮播图列表
  .bannerImg {
    width: 180px;
    height: 70px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bannerList {
    width: 100%;
  }

  // 新增图片
  .addBanner {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
  }

  .bannnerLi {
    width: 100%;
    margin-bottom: 30px;

    .title {
      width: 110px;
      flex-shrink: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/DIY/index.vue